import { createContext, useContext, useEffect } from "react";

// Fonctionnalité de lecture vocale des news désactivée.
const Ctx = createContext({ voiceOn: false });
export const useNewsVoice = () => useContext(Ctx);

export function NewsVoiceProvider({ children }) {
  useEffect(() => {
    try { localStorage.removeItem("newsVoiceOn"); } catch { /* noop */ }
    if (typeof window !== "undefined") window.speechSynthesis?.cancel();
  }, []);
  return <Ctx.Provider value={{ voiceOn: false }}>{children}</Ctx.Provider>;
}
